export default {
  Login: 'api/public/login',
  Logout: 'api/public/logout',
  Register: 'api/public/register',
  ForgetPassword : 'api/public/forgot_password',
  ResetPassword : 'api/public/reset_password',
  ActivateAnAccount : 'api/public/active'
};
